export class Pagination {
  limit = 10;
  offset = 0;
}
